import { render } from "./CutleryDisinfection.vue?vue&type=template&id=30813c82&scoped=true"
import script from "./CutleryDisinfection.vue?vue&type=script&lang=js"
export * from "./CutleryDisinfection.vue?vue&type=script&lang=js"

import "./CutleryDisinfection.vue?vue&type=style&index=0&id=30813c82&scoped=true&lang=scss"

import exportComponent from "E:\\Project\\one-code-pass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30813c82"]])

export default __exports__